export default __webpack_public_path__ + "static/hero-9df00819b6db05535f8f75a837dacd0f.jpg";